import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { tokenNotExpired } from 'angular2-jwt';
import { HttpClientModule } from '@angular/common/http';
import { Location } from '@angular/common';
import { HttpModule } from '@angular/http';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _location: Location) {
    }

    isLoggedIn() {
        return tokenNotExpired();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const permission = route.children[0].data.permission;
        if (tokenNotExpired()) {
            let flag = 0;
            const AuthUserPermission = JSON.parse(localStorage.getItem('permissions'));
            for (let i = 0; i < AuthUserPermission.length; i++) {
                for (let j = 0; j < permission.length; j++) {
                    if (AuthUserPermission[i] === permission[j]) {
                        flag = 1;
                    }
                }
            }
            if (flag === 1) {
                // console.log('yes');
                return true;
            } else {
                // console.log('no');
                this._router.navigate(['/dashboard']);
                return false;
            }
        } else {
            if (localStorage.getItem('token')) {
                localStorage.removeItem('token');
                localStorage.removeItem('currentUser');
                localStorage.removeItem('permissions');
            }
            this._router.navigate(['/login']);
            return false;

        }
    }
}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/guards/auth.guard.ts